





























import {
  BARCODE_TYPE,
  CDKEY_SHOW_TYPE,
} from '@/api/displayCoupon/display-coupon';
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  formatCdKey,
  getBarCode as getCodeImgUrl,
} from '../../business/display-coupon-record';
import QRCode from 'qrcode';
import { CustomException } from '@tencent/ppd-base-libs';

const {
  CODE,
  CODE_BARCODE,
  CODE_QRCODE,
  CODE_BARCODE_QRCODE,
  BARCODE,
  BARCODE_QRCODE,
  QRCODE,
} = CDKEY_SHOW_TYPE;

@Component
export default class CDKeyCode extends Vue {
  /** cdkey 类型 */
  @Prop({ default: () => {} })
  private cdkeyType!: CDKEY_SHOW_TYPE;
  /** cdkey */
  @Prop({ default: '' })
  private cdkey!: string;
  /** 商户名称 */
  @Prop({ default: '' })
  private spName!: string;
  /** barcode type */
  @Prop({ default: '' }) private barcodeType!: BARCODE_TYPE;
  /** 二维码图片 */
  private qrcodeUrl = '';
  /** 条形码图片 */
  private barcodeUrl = '';
  /** 拆分cdkey */
  private formatCdKey = formatCdKey;

  /** 是否展示条形码 */
  private get isShowBarCode() {
    return [
      BARCODE,
      CODE_BARCODE,
      BARCODE_QRCODE,
      CODE_BARCODE_QRCODE,
    ].includes(this.cdkeyType);
  }
  /** 是否展示二维码*/
  private get isShowQrCode() {
    return [QRCODE, CODE_QRCODE, BARCODE_QRCODE, CODE_BARCODE_QRCODE].includes(this.cdkeyType);
  }
  /** 是否展示code */
  private get isShowCode() {
    return [CODE, CODE_BARCODE, CODE_QRCODE, CODE_BARCODE_QRCODE].includes(this.cdkeyType);
  }
  /** 格式化后的cdkey */
  private get formatCode() {
    if (this.isShowBarCode) return formatCdKey(this.cdkey);
    return this.cdkey;
  }
  /** ean13编码的barcode需要fix height */
  private get fixHeightClass() {
    return this.barcodeType === BARCODE_TYPE.ean13 ? 'fix-height' : '';
  }
  /** 是否是百佳商户 */
  private get isBJ() {
    return ['百佳超级市场', '百佳超級市場', 'PARKnSHOP', '屈臣氏', '屈臣氏', 'Watsons'].includes(this.spName);
  }
  private created() {
    if (!this.isBJ) {
      this.qrcodeUrl = getCodeImgUrl(this.cdkey, 'qrcode');
    }
    this.barcodeUrl = getCodeImgUrl(this.cdkey, 'barcode', {
      barcodeType: this.barcodeType,
    });
  }
  private mounted() {
    if (this.isBJ) {
      this.generateBJQRCode();
    }
  }
  // 生成通用的百佳二维码
  private generateBJQRCode() {
    setTimeout(() => {
      const fontSize = parseFloat(document.documentElement.style.fontSize);
      const width = (320 / 200) * fontSize;
      const height = (320 / 200) * fontSize;
      const canvas = document.getElementById('qr-code-canvas');
      QRCode.toCanvas(canvas, this.cdkey, {
        version: 1,
        errorCorrectionLevel: 'L',
        width,
        height,
        margin: 0,
      }, (error) => {
        if (error) new CustomException(error, 'BJQRCodeFail', '百佳商户二维码生成失败');
      });
    }, 200);
  }
}
